import { Component, ContentChildren, Directive, ElementRef, Input, QueryList, TemplateRef } from '@angular/core';
import { CommonModule } from '@angular/common';


@Directive({
    selector: '[jdTabContent]',
    standalone: true,
})
export class JdTabContentDirective {
    @Input('jdTabContent') key!: string;
    constructor(public template: TemplateRef<unknown>) { }
}

@Component({
    selector: 'app-jd-tabs',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './jd-tabs.component.html'
})
export class JdTabsComponent {
    @ContentChildren(JdTabContentDirective) tabDirectives!: QueryList<JdTabContentDirective>;

    tabKeys: string[] = [];
    selected: string | null = null;

    ngAfterContentInit() {
        this.tabKeys = this.tabDirectives.map(d => d.key);
        this.selected = this.tabKeys[0] ?? null;
    }

    select(key: string) {
        this.selected = key;
    }

    get selectedTemplate() {
        return this.tabDirectives.find(d => d.key === this.selected)?.template;
    }
}
